<template>
  <v-data-table
    :headers="tableHeaders"
    :items="items"
    :options.sync="options"
    :items-per-page="totalItems"
    :server-items-length="totalItems"
    :loading="isLoadingBillOfLading"
    :expanded.sync="expanded"
    loading-text="Loading... Please wait"
    :footer-props="{
      showFirstLastPage: true,
      itemsPerPageOptions: rowsPerPageItems,
      firstIcon: 'mdi-arrow-collapse-left',
      lastIcon: 'mdi-arrow-collapse-right',
    }"
    @update:options="getDataFromApi"
  >
    <template v-slot:[`item.name`]="{ item }">
      <span v-if="item.name">
        {{ item.name }}/{{ item.protocolDate | moment("DD.MM.YYYY") }}
      </span>
    </template>

    <template v-slot:[`item.actions`]="{ item }">
      <router-link
        v-if="checkIfUserHasPermission(['protocols-update'])"
        :to="{ name: 'edit-protocols', params: { id: item.id } }"
      >
        <v-tooltip right>
          <template v-slot:activator="{ on, attrs }">
            <v-btn class="mr-2" fab dark x-small v-bind="attrs" v-on="on">
              <v-icon dark>mdi-pencil</v-icon>
            </v-btn>
          </template>
          <span>{{ $t("LABELS.EDIT") }}</span>
        </v-tooltip>
      </router-link>
    </template>
    <template v-slot:no-results>
      <v-alert :value="true" color="error" icon="warning">
        Your search for "{{ searchQuery }}" found no results.
      </v-alert>
    </template>
  </v-data-table>
</template>

<script>
import { permissionMixin } from "@/core/mixins/permissionMixin.js";
import { FETCH_PROTOCOLS } from "@/modules/protocols/store/protocol.module";

export default {
  name: "ProtocolsNotFinishedTable",
  mixins: [permissionMixin],
  data() {
    return {
      items: [],
      totalItems: 100,
      options: {
        sortBy: ["protocolDate"],
        sortDesc: [false],
        page: 1,
        length: 5,
        itemsPerPage: 5,
        query: "",
        finishedFilter: 0,
      },
      tableLoading: true,
      expanded: [],
      rowsPerPageItems: [10, 20, 30, 40, 50],
      tableHeaders: [
        {
          text: this.$i18n.t("MENU.ITEM.ASL.ASSIGNOR"),
          value: "assignorName",
          sortable: false,
        },
        {
          text: this.$i18n.t("MENU.ITEM.ASL.LOCATION"),
          value: "locationName",
          sortable: false,
        },
        { text: this.$i18n.t("FORM_LABELS.PROTOCOL"), value: "name" },
        {
          align: "right",
          text: "",
          value: "actions",
          sortable: false,
          width: "10%",
        },
      ],
    };
  },
  methods: {
    getDataFromApi() {
      this.options.start =
        this.options.page == 1
          ? 0
          : this.options.itemsPerPage * (this.options.page - 1); //set offset
      let apiParams = this.$url.transformParams(this.options);
      this.$store.dispatch(FETCH_PROTOCOLS, apiParams).then((data) => {
        this.$nextTick(function() {
          this.items = data.data.items;
          this.totalItems = data.data.totalItemsCount;
        });
      });
    },
  },
};
</script>

<style></style>
